import { render, staticRenderFns } from "./gruppiStatoPolize.vue?vue&type=template&id=a83feada&"
import script from "./gruppiStatoPolize.vue.ts?vue&type=script&lang=ts&"
export * from "./gruppiStatoPolize.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports